import { createAction } from 'typesafe-actions';

import ExternalActions from '../constants/External';

interface RelayExternalApiCallParams extends $TSFixMe {}

interface RelayExternalApiCallPayload {
  params: RelayExternalApiCallParams;
}

export const relayExternalApiCall = createAction(
  ExternalActions.RELAY_EXTERNAL_API_CALL,
  (params: RelayExternalApiCallParams) => ({ params }),
)<RelayExternalApiCallPayload>();
export type RelayExternalApiCallAction = ReturnType<typeof relayExternalApiCall>;
